import { render, staticRenderFns } from "./QuestionEditor.vue?vue&type=template&id=5141400c&"
import script from "./QuestionEditor.vue?vue&type=script&lang=ts&"
export * from "./QuestionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports